module.exports = __webpack_public_path__ + "static/media/front_05.36566edc.png";